import { api } from '../services/api'
import {
  TWITTER_LOGIN_PENDING,
  TWITTER_LOGIN_SUCCESS,
  TWITTER_LOGIN_FAIL,
  CLEAR_TWITTER_ERROR,
} from '../actions/index'


const initialState = {
  access_token: null,
  refresh_token: null,
  expires_in: null,
  expires_at: null,
  scope: null,
  signInError: '',
  loading: false,
}

export default function twitter(state = initialState, action) {
  switch (action.type) {
    case TWITTER_LOGIN_PENDING: {
      return {
        ...state,
        access_token: null,
        refresh_token: null,
        expires_in: null,
        expires_at: null,
        scope: null,
        signInError: '',
        loading: true,
      }
    }

    case TWITTER_LOGIN_SUCCESS: {
      return {
        ...state,
        scope: action.payload.data.scope,
        access_token: action.payload.data.access_token,
        refresh_token: action.payload.data.refresh_token,
        expires_in: action.payload.data.expires_in,
        expires_at: action.payload.data.expires_at,
        loading: false,
      }
    }

    case TWITTER_LOGIN_FAIL: {
      return {
        ...state,
        signInError: api.stringifyResponseErrors(action.payload.data),
        loading: false,
      }
    }

    case CLEAR_TWITTER_ERROR: {
      return {
        ...state,
        signInError: '',
        loading: false,
      }
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/twitter.js